<template>
  <el-form @submit.native.prevent="$emit('save')" >
    <h3>Views</h3>
    <component
       :is="display.container.name"
       v-model="activeName"
       :accordion="display.container.accordion" >
      <component
         :is="display.item.name"
         label="Vue"
         title="Vue"
         name="main" >
        <el-form-item label="View" >
          <el-select
            v-model="view"
            value-key="uniqueName"
            @change="() => columns.splice(0, columns.length)" >
            <el-option v-for="v in views" :key="v.uniqueName" :label="v.name" :value="v" />
          </el-select>
        </el-form-item>
        <el-form-item label="Colonnes" class="columns" >
          <el-select v-if="view" v-model="columns" :multiple="true" value-key="uniqueName" >
            <el-option
              v-for="column in view.columns"
              :key="column.uniqueName"
              :label="column.name"
              :value="column" />
          </el-select>
        </el-form-item>
      </component>
      <component
         :is="display.item.name"
         label="Filtres"
         title="Filtres"
         name="filter" >
        <filters-editor v-model="filters" :dimensions="dimensions" />
      </component>
    </component>
    <div style="text-align: right;" >
      <el-button :plain="true" native-type="submit">
        Sauvegarder
      </el-button>
    </div>
  </el-form>
</template>

<script>
import FiltersEditor from './components/FiltersEditor'

export default {
  components: {
    FiltersEditor
  },
  props: {
    viewsConfig: {
      type: Object
    },
    dimensions: {
      type: [Array, Object],
      default: () => []
    },
    filter: {
      type: [Array, Object],
      default: () => []
    },
    display: {
      type: Object,
      default () {
        return {
          container: {
            name: 'el-tabs',
            accordion: false
          },
          item: {
            name: 'el-tab-pane'
          }
        }
      }
    }
  },
  data () {
    return {
      view: this.viewsConfig.view || null,
      columns: this.viewsConfig.columns || [],
      filters: this.filter || [],
      activeName: 'main'
    }
  },
  watch: {
    view () {
      this.update()
    },
    columns () {
      this.update()
    },
    filters () {
      this.$emit('update:filter', this.filters)
    }
  },
  mounted () {
    this.load()
  },
  computed: {
    views () {
      return this.$store.getters['customGraph/views']
    }
  },
  methods: {
    load () {
      this.$store.dispatch('customGraph/loadViews')
    },
    update () {
      this.$emit('update:viewsConfig', {
        view: this.view,
        columns: this.columns
      })
    }
  }
}
</script>

<style scoped>
.columns {
    display: flex;
    flex-direction: column;
    align-items: stretch;
}
.columns >>> .el-form-item__label {
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/ViewsWidgetEdit.vue